@if (loading) {
  @for (number of [].constructor(2); track $index) {
    <div class="card mt-4 mb-4">
      <div class="card-body">
        <div class="placeholder w-100"></div>
        <div class="placeholder w-100"></div>
      </div>
    </div>
  }
}
@if (!loading) {
  <div class="card mb-4">
    <div class="card-header text-end">
      <button type="button" class="btn btn-primary btn-sm" (click)="addLeg()">
        <fa-icon [icon]="faPlus"></fa-icon> {{ "GENERAL.ADD" | translate }}
      </button>
    </div>
    @if (!enquiryFlights.length) {
      <div class="card-body">
        <div
          class="alert alert-warning text-center mb-0"
          [innerText]="'GENERAL.NO_DATA_TO_DISPLAY' | translate"
        ></div>
      </div>
    }
    <div class="accordion accordion-flush" id="accordion-enquiry-flights">
      @for (enquiryFlight of enquiryFlights; track enquiryFlight.id; let i = $index) {
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              [class.collapsed]="i > 0"
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#enquiry-flight-' + i"
              aria-expanded="false"
              [attr.aria-controls]="'enquiry-flight-' + i"
              >
              <div
                class="d-md-flex flex-columns justify-content-between align-items-center w-100 me-2"
                >
                <div
                                [innerText]="'FLIGHTS.LEG_X'
                        | translate
                            : {
                                  number: i + 1,
                                  airportDepart: enquiryFlight.airportDepartIataCode || '?',
                                  airportArrival:
                                      enquiryFlight.airportArrivalIataCode || '?',
                              }"
                ></div>
                <div
                                [innerText]="
                                    enquiryFlight.departDateTimeLocal
                                    | date : 'EE dd MMM yyyy HH:mm' : undefined : dateLocale
                                "
                ></div>
              </div>
            </button>
          </h2>
          <div
            [id]="'enquiry-flight-' + i"
            class="accordion-collapse collapse"
            [class.show]="i === 0"
            data-bs-parent="#accordion-enquiry-flights"
            >
            <div class="accordion-body">
              <div class="btn-toolbar justify-content-end mb-2 gap-2">
                <div class="btn-group">
                  @if (
                    hasAclAccess(EnumAcl.flightChecklistsView) &&
                    !noChecklistBtn
                    ) {
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      (click)="viewFlightChecklist(enquiryFlight)"
                      >
                      Checklist
                      @if (
                        flightChecklistTemplateByEnquiryType[
                        enquiryFlight.enquiryType
                        ]
                        ) {
                        <span
                          class="ms-2"
                                        [innerText]="
                                            getFinishedCheckOnTotalForFlight(
                                                flightChecklistTemplateByEnquiryType[
                                                    enquiryFlight.enquiryType
                                                ],
                                                flightChecklistByEnquiryFlight[enquiryFlight.id]
                                            )
                                        "
                        ></span>
                      }
                    </button>
                  }
                </div>
                <div class="btn-group">
                  @if (!noDeleteBtn) {
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      [appTooltip]="'GENERAL.DELETE' | translate"
                      (click)="deleteLeg(enquiryFlight)"
                      >
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  }
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    [appTooltip]="'GENERAL.EDIT' | translate"
                    (click)="editLeg(enquiryFlight)"
                    >
                    <fa-icon [icon]="faEdit"></fa-icon>
                  </button>
                </div>
              </div>
              <div class="row flight-itinerary">
                <div class="col-lg-4">
                  <div class="flight-itinerary-airport">
                    <fa-icon [icon]="faPlaneDeparture"></fa-icon>
                    <a
                                        [routerLink]="
                                            '/admin/airports/' + enquiryFlight.airportDepartId
                                        "
                      target="_blank"
                      >
                      {{ enquiryFlight.airportDepartIataCode }}</a
                      ><br />
                      @if (airportsObj[enquiryFlight.airportDepartId]?.icaoCode) {
                        <div
                          >
                          ICAO:
                          {{ airportsObj[enquiryFlight.airportDepartId]?.icaoCode }}
                        </div>
                      }
                      {{ enquiryFlight.airportDepartTitle }}
                    </div>
                    <div class="flight-itinerary-datetime">
                      {{
                      enquiryFlight.departDateLocal
                      | date : "EE dd MMM yyyy" : undefined : dateLocale
                      }}<br />
                      <strong>{{ "GENERAL.LT" | translate }} :</strong>
                      {{ enquiryFlight.departTimeLocal }}<br />
                      <strong>{{ "GENERAL.UTC" | translate }} :</strong>
                      {{ enquiryFlight.departTimeUtc }}
                      @if (enquiryFlight.departSlotEnabled) {
                        <div>
                          <strong>{{ "CALENDAR.SLOT" | translate }} :</strong>
                          {{ enquiryFlight.departSlotTime }} LT
                        </div>
                      }
                      @if (enquiryFlight.departTerminalEnabled) {
                        <div>
                          <strong>{{ "CALENDAR.TERMINAL" | translate }} :</strong>
                          {{ enquiryFlight.departTerminal }}
                        </div>
                      }
                    </div>
                    @if (enquiryFlight.departFboEnabled) {
                      <div
                        class="card card-child mt-4 mb-4"
                        >
                        <div
                          class="card-header d-flex justify-content-between align-items-center"
                          >
                          <span class="fake-btn"></span>
                          {{ "CALENDAR.FBO_DEPARTURE" | translate }}
                          <a
                                            [routerLink]="
                                                '/admin/fbos/' + enquiryFlight.departFboId
                                            "
                            class="btn btn-light btn-sm"
                            target="_blank"
                            ><fa-icon [icon]="faEye"></fa-icon
                          ></a>
                        </div>
                        <div class="card-body placeholder-glow">
                          @if (!fbosObj[enquiryFlight.departFboId]) {
                            @for (number of [].constructor(4); track $index) {
                              <div
                                class="placeholder w-100"
                              ></div>
                            }
                          }
                          @if (fbosObj[enquiryFlight.departFboId]) {
                            <strong
                                                [innerText]="
                                                    fbosObj[enquiryFlight.departFboId].name
                                                "
                            ></strong>
                            <div
                                                [innerHTML]="
                                                    getFboFullAddress(
                                                        fbosObj[enquiryFlight.departFboId]
                                                    )
                                                "
                            ></div>
                            @if (
                              fbosObj[enquiryFlight.departFboId].phoneNumber
                              ) {
                              <div
                                >
                                {{ "GENERAL.PHONE" | translate }} :
                                <a
                                                    [href]="
                                                        'tel:' +
                                                        fbosObj[enquiryFlight.departFboId]
                                                            .phoneNumber
                                                    "
                                                    [innerText]="
                                                        fbosObj[enquiryFlight.departFboId]
                                                            .phoneNumber
                                                    "
                                ></a>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                    @if (enquiryFlight.departAgentEnabled) {
                      <div
                        class="card card-child mt-4 mb-4"
                        >
                        <div
                          class="card-header text-center"
                          [innerText]="'CALENDAR.REPRESENTATIVE' | translate"
                        ></div>
                        <div class="card-body placeholder-glow">
                          @if (enquiryFlight.departAgentUserId) {
                            <a
                                            [routerLink]="
                                                '/admin/users/' + enquiryFlight.departAgentUserId
                                            "
                                            [innerText]="
                                                enquiryFlight.departAgentUserFullName +
                                                ' (' +
                                                enquiryFlight.departAgentUserInitials +
                                                ')'
                                            "
                            ></a>
                          }
                          @if (!enquiryFlight.departAgentUserId) {
                            <strong
                              [innerText]="enquiryFlight.departAgentUserFullName"
                            ></strong>
                          }
                          @if (enquiryFlight.departAgentCompany) {
                            <div>
                              {{ "GENERAL.COMPANY" | translate }} :
                              {{ enquiryFlight.departAgentCompany }}
                            </div>
                          }
                          @if (enquiryFlight.departAgentPhone) {
                            <div>
                              {{ "GENERAL.PHONE" | translate }} :
                              <a
                                [href]="'tel:' + enquiryFlight.departAgentPhone"
                                [innerText]="enquiryFlight.departAgentPhone"
                              ></a>
                            </div>
                          }
                          @if (enquiryFlight.departAgentEmail) {
                            <div>
                              {{ "GENERAL.EMAIL" | translate }} :
                              <a
                                [href]="'mailto:' + enquiryFlight.departAgentEmail"
                                [innerText]="enquiryFlight.departAgentEmail"
                              ></a>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (enquiryFlight.departHandlingEnabled) {
                      <div
                        class="card card-child mt-4 mb-4"
                        >
                        <div
                          class="card-header d-flex justify-content-between align-items-center"
                          >
                          <span class="fake-btn"></span>
                          {{ "CALENDAR.HANDLING_DEPARTURE" | translate }}
                          <a
                                            [routerLink]="
                                                '/admin/handlings/' + enquiryFlight.departHandlingId
                                            "
                            class="btn btn-light btn-sm"
                            target="_blank"
                            ><fa-icon [icon]="faEye"></fa-icon
                          ></a>
                        </div>
                        <div class="card-body placeholder-glow">
                          @if (!handlingsObj[enquiryFlight.departHandlingId]) {
                            @for (number of [].constructor(4); track $index) {
                              <div
                                class="placeholder w-100"
                              ></div>
                            }
                          }
                          @if (handlingsObj[enquiryFlight.departHandlingId]) {
                            <strong
                                                [innerText]="
                                                    handlingsObj[enquiryFlight.departHandlingId]
                                                        .name
                                                "
                            ></strong>
                            <div
                                                [innerHTML]="
                                                    getHandlingFullAddress(
                                                        handlingsObj[enquiryFlight.departHandlingId]
                                                    )
                                                "
                            ></div>
                            @if (
                              handlingsObj[enquiryFlight.departHandlingId]
                              .email
                              ) {
                              <div
                                >
                                {{ "GENERAL.EMAIL" | translate }} :
                                <a
                                                    [href]="
                                                        'mailto:' +
                                                        handlingsObj[enquiryFlight.departHandlingId]
                                                            .email
                                                    "
                                                    [innerText]="
                                                        handlingsObj[enquiryFlight.departHandlingId]
                                                            .email
                                                    "
                                ></a>
                              </div>
                            }
                            @if (
                              handlingsObj[enquiryFlight.departHandlingId]
                              .phoneNumber
                              ) {
                              <div
                                >
                                {{ "GENERAL.PHONE" | translate }} :
                                <a
                                                    [href]="
                                                        'tel:' +
                                                        handlingsObj[enquiryFlight.departHandlingId]
                                                            .phoneNumber
                                                    "
                                                    [innerText]="
                                                        handlingsObj[enquiryFlight.departHandlingId]
                                                            .phoneNumber
                                                    "
                                ></a>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-lg-4">
                    <div class="flight-time mt-2 mb-2">
                      <div
                        [class.text-muted]="!enquiryFlight.flightNumber"
                                        [innerText]="
                                            enquiryFlight.flightNumber || ('ENQUIRY_FLIGHTS.FLIGHT_NUMBER_TO_SPECIFY' | translate)
                                        "
                      ></div>
                      <div
                        class="small"
                        [class.text-muted]="!enquiryFlight.callsign"
                                        [innerText]="
                                            enquiryFlight.callsign ||
                                            ('GENERAL.UNKNOWN' | translate)
                                        "
                      ></div>
                      <fa-icon [icon]="faClock"></fa-icon>
                      @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) > 0) {
                        <span
                                        [innerText]="
                                            convertMinutesToTime(
                                                getEnquiryFlightFlyTimeInMin(enquiryFlight),
                                                'h ',
                                                'min'
                                            )
                                        "
                        ></span>
                      }
                      @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) < 0) {
                        <div
                          class="alert alert-danger text-center"
                          >
                          {{ "CALENDAR.FLIGHT_TIME_ERROR" | translate }}
                        </div>
                      }
                      @if (getEnquiryFlightFlyTimeInMin(enquiryFlight) === 0) {
                        <div
                          class="text-muted"
                          >
                          {{ "CALENDAR.FLIGHT_DURATION_UNKNOWN" | translate }}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="flight-itinerary-airport">
                      <fa-icon [icon]="faPlaneArrival"></fa-icon>
                      <a
                                        [routerLink]="
                                            '/admin/airports/' + enquiryFlight.airportArrivalId
                                        "
                        target="_blank"
                        >
                        {{ enquiryFlight.airportArrivalIataCode }} </a
                        ><br />
                        @if (airportsObj[enquiryFlight.airportArrivalId]?.icaoCode) {
                          <div
                            >
                            ICAO:
                            {{ airportsObj[enquiryFlight.airportArrivalId]?.icaoCode }}
                          </div>
                        }
                        {{ enquiryFlight.airportArrivalTitle }}
                      </div>
                      <div class="flight-itinerary-datetime">
                        @if (
                          enquiryFlight.departDateTimeUtc ===
                          enquiryFlight.arrivalDateTimeUtc
                          ) {
                          <span
                            class="text-muted"
                            >{{
                            "ENQUIRY_FLIGHTS.ARRIVAL_DATE_TIME_TBD" | translate
                            }}</span
                            >
                          }
                          @if (
                            enquiryFlight.departDateTimeUtc !==
                            enquiryFlight.arrivalDateTimeUtc
                            ) {
                            {{
                            enquiryFlight.arrivalDateLocal
                      | date : "EE dd MMM yyyy" : undefined : dateLocale
                            }}<br />
                            <strong>{{ "GENERAL.LT" | translate }} :</strong>
                            {{ enquiryFlight.arrivalTimeLocal }}<br />
                            <strong>{{ "GENERAL.UTC" | translate }} :</strong>
                            {{ enquiryFlight.arrivalTimeUtc }}
                          }
                          @if (enquiryFlight.arrivalSlotEnabled) {
                            <div>
                              <strong>{{ "ENQUIRIES.SLOT" | translate }} :</strong>
                              {{ enquiryFlight.arrivalSlotTime }} LT
                            </div>
                          }
                          @if (enquiryFlight.arrivalTerminalEnabled) {
                            <div>
                              <strong>{{ "ENQUIRIES.TERMINAL" | translate }} :</strong>
                              {{ enquiryFlight.arrivalTerminal }}
                            </div>
                          }
                          @if (enquiryFlight.isAircraftGroundedOnArrival) {
                            <div>
                              {{ "CALENDAR.GROUNDED_ON_ARRIVAL" | translate }}
                            </div>
                          }
                        </div>
                        @if (enquiryFlight.arrivalFboEnabled) {
                          <div
                            class="card card-child mt-4 mb-4"
                            >
                            <div
                              class="card-header d-flex justify-content-between align-items-center"
                              >
                              <span class="fake-btn"></span>
                              {{ "CALENDAR.FBO_ARRIVAL" | translate }}
                              <a
                                            [routerLink]="
                                                '/admin/fbos/' + enquiryFlight.arrivalFboId
                                            "
                                class="btn btn-light btn-sm"
                                target="_blank"
                                ><fa-icon [icon]="faEye"></fa-icon
                              ></a>
                            </div>
                            <div class="card-body placeholder-glow">
                              @if (!fbosObj[enquiryFlight.arrivalFboId]) {
                                @for (number of [].constructor(4); track $index) {
                                  <div
                                    class="placeholder w-100"
                                  ></div>
                                }
                              }
                              @if (fbosObj[enquiryFlight.arrivalFboId]) {
                                <strong
                                                [innerText]="
                                                    fbosObj[enquiryFlight.arrivalFboId].name
                                                "
                                ></strong>
                                <div
                                                [innerHTML]="
                                                    getFboFullAddress(
                                                        fbosObj[enquiryFlight.arrivalFboId]
                                                    )
                                                "
                                ></div>
                                @if (
                                  fbosObj[enquiryFlight.arrivalFboId].phoneNumber
                                  ) {
                                  <div
                                    >
                                    {{ "GENERAL.PHONE" | translate }} :
                                    <a
                                                    [href]="
                                                        'tel:' +
                                                        fbosObj[enquiryFlight.arrivalFboId]
                                                            .phoneNumber
                                                    "
                                                    [innerText]="
                                                        fbosObj[enquiryFlight.arrivalFboId]
                                                            .phoneNumber
                                                    "
                                    ></a>
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                        @if (enquiryFlight.arrivalAgentEnabled) {
                          <div
                            class="card card-child mt-4 mb-4"
                            >
                            <div
                              class="card-header text-center"
                              [innerText]="'CALENDAR.REPRESENTATIVE_ARRIVAL' | translate"
                            ></div>
                            <div class="card-body placeholder-glow">
                              @if (enquiryFlight.arrivalAgentUserId) {
                                <a
                                            [routerLink]="
                                                '/admin/users/' + enquiryFlight.arrivalAgentUserId
                                            "
                                            [innerText]="
                                                enquiryFlight.arrivalAgentUserFullName +
                                                ' (' +
                                                enquiryFlight.arrivalAgentUserInitials +
                                                ')'
                                            "
                                ></a>
                              }
                              @if (!enquiryFlight.arrivalAgentUserId) {
                                <strong
                                  [innerText]="enquiryFlight.arrivalAgentUserFullName"
                                ></strong>
                              }
                              @if (enquiryFlight.arrivalAgentCompany) {
                                <div>
                                  {{ "GENERAL.COMPANY" | translate }} : {{ enquiryFlight.arrivalAgentCompany }}
                                </div>
                              }
                              @if (enquiryFlight.arrivalAgentPhone) {
                                <div>
                                  {{ "GENERAL.PHONE" | translate }} :
                                  <a
                                    [href]="'tel:' + enquiryFlight.arrivalAgentPhone"
                                    [innerText]="enquiryFlight.arrivalAgentPhone"
                                  ></a>
                                </div>
                              }
                              @if (enquiryFlight.arrivalAgentEmail) {
                                <div>
                                  {{ "GENERAL.EMAIL" | translate }} :
                                  <a
                                    [href]="'mailto:' + enquiryFlight.arrivalAgentEmail"
                                    [innerText]="enquiryFlight.arrivalAgentEmail"
                                  ></a>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (enquiryFlight.arrivalHandlingEnabled) {
                          <div
                            class="card card-child mt-4 mb-4"
                            >
                            <div
                              class="card-header d-flex justify-content-between align-items-center"
                              >
                              <span class="fake-btn"></span>
                              {{ "CALENDAR.HANDLING_ARRIVAL" | translate }}
                              <a
                                            [routerLink]="
                                                '/admin/handlings/' +
                                                enquiryFlight.arrivalHandlingId
                                            "
                                class="btn btn-light btn-sm"
                                target="_blank"
                                ><fa-icon [icon]="faEye"></fa-icon
                              ></a>
                            </div>
                            <div class="card-body placeholder-glow">
                              @if (!handlingsObj[enquiryFlight.arrivalHandlingId]) {
                                @for (number of [].constructor(4); track $index) {
                                  <div
                                    class="placeholder w-100"
                                  ></div>
                                }
                              }
                              @if (handlingsObj[enquiryFlight.arrivalHandlingId]) {
                                <strong
                                                [innerText]="
                                                    handlingsObj[enquiryFlight.arrivalHandlingId]
                                                        .name
                                                "
                                ></strong>
                                <div
                                                [innerHTML]="
                                                    getHandlingFullAddress(
                                                        handlingsObj[
                                                            enquiryFlight.arrivalHandlingId
                                                        ]
                                                    )
                                                "
                                ></div>
                                @if (
                                  handlingsObj[enquiryFlight.arrivalHandlingId]
                                  .email
                                  ) {
                                  <div
                                    >
                                    {{ "GENERAL.EMAIL" | translate }} :
                                    <a
                                                    [href]="
                                                        'mailto:' +
                                                        handlingsObj[
                                                            enquiryFlight.arrivalHandlingId
                                                        ].email
                                                    "
                                                    [innerText]="
                                                        handlingsObj[
                                                            enquiryFlight.arrivalHandlingId
                                                        ].email
                                                    "
                                    ></a>
                                  </div>
                                }
                                @if (
                                  handlingsObj[enquiryFlight.arrivalHandlingId]
                                  .phoneNumber
                                  ) {
                                  <div
                                    >
                                    {{ "GENERAL.PHONE" | translate }} :
                                    <a
                                                    [href]="
                                                        'tel:' +
                                                        handlingsObj[
                                                            enquiryFlight.arrivalHandlingId
                                                        ].phoneNumber
                                                    "
                                                    [innerText]="
                                                        handlingsObj[
                                                            enquiryFlight.arrivalHandlingId
                                                        ].phoneNumber
                                                    "
                                    ></a>
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-4">
                        <div class="card card-child mb-4">
                          <div class="card-header">{{ "CALENDAR.AIRCRAFT_DETAILS" | translate }}</div>
                          <div class="card-body">
                            {{ "FLIGHT_BRIEF.REGISTRATION" | translate }} :
                            @if (!enquiryFlight.aircraftId) {
                              <span
                                class="text-muted"
                                >{{ "GENERAL.TO_BE_DEFINED" | translate }}</span
                                >
                              }
                              @if (enquiryFlight.aircraftId) {
                                <a
                                            [routerLink]="
                                                '/admin/aircrafts/' + enquiryFlight.aircraftId
                                            "
                                  target="_blank"
                                  >
                                  {{
                                  enquiryFlight.aircraftRegistration ||
                                  ("FLIGHT_BRIEF.REGISTRATION_UNKNOWN" | translate)
                                  }}</a
                                  >
                                  }<br />
                                  {{ "GENERAL.MODEL" | translate }}:
                                  @if (!enquiryFlight.aircraftModelId) {
                                    <span
                                      class="text-muted"
                                      >{{ "GENERAL.TO_BE_DEFINED" | translate }}</span
                                      >
                                    }
                                    @if (enquiryFlight.aircraftModelId) {
                                      <a
                                            [routerLink]="
                                                '/admin/aircraft-models/' +
                                                enquiryFlight.aircraftModelId
                                            "
                                        target="_blank"
                                        >
                                        {{ enquiryFlight.aircraftModelTitle }}</a
                                        >
                                        }<br />
                                        {{ "GENERAL.OPERATOR" | translate }} :
                                        @if (!enquiryFlight.airlineId) {
                                          <span class="text-muted">{{
                                            "GENERAL.TO_BE_DEFINED" | translate
                                          }}</span>
                                        }
                                        @if (enquiryFlight.airlineId) {
                                          <a
                                            [routerLink]="
                                                '/admin/airlines/' + enquiryFlight.airlineId
                                            "
                                            target="_blank"
                                            >
                                            {{ enquiryFlight.airlineTitle }}</a
                                            >
                                            }<br />
                                            {{ "GENERAL.NATIONALITY" | translate }} :
                                            {{
                                            enquiryFlight.countryCode
                                            ? countries[enquiryFlight.countryCode]
                                            : ("GENERAL.TO_BE_DEFINED" | translate)
                                            }}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="card card-child mb-4">
                                          <div
                                            class="card-header"
                                        [innerText]="
                                            [
                                                EnumEnquiryType.cargo,
                                                EnumEnquiryType.commercial
                                            ].includes($safeNavigationMigration(enquiry?.type))
                                                ? ('CALENDAR.OPERATOR_DETAILS' | translate)
                                                : ('CALENDAR.CREW_DETAILS' | translate)
                                        "
                                          ></div>
                                          <ul
                                            class="list-group list-group-flush placeholder-glow list-group-crew"
                                            >
                                            <li class="list-group-item">
                                              <label>{{ "GENERAL.SALES_H24" | translate }} :</label>&nbsp;
                                              @if (!enquiryFlight.salesH24Phone) {
                                                <span
                                                  class="text-muted"
                                                  >
                                                  {{ "GENERAL.TO_BE_DEFINED" | translate }}
                                                </span>
                                              }
                                              @if (enquiryFlight.salesH24Phone) {
                                                <span
                                                  [innerText]="enquiryFlight.salesH24Phone"
                                                ></span>
                                              }
                                            </li>
                                            <li class="list-group-item">
                                              <label>{{ "GENERAL.OPS_H24" | translate }} :</label>&nbsp;
                                              @if (!enquiryFlight.opsH24Phone) {
                                                <span
                                                  class="text-muted"
                                                  >
                                                  {{ "GENERAL.TO_BE_DEFINED" | translate }}
                                                </span>
                                              }
                                              @if (enquiryFlight.opsH24Phone) {
                                                <span
                                                  [innerText]="enquiryFlight.opsH24Phone"
                                                ></span>
                                              }
                                            </li>
                                            @if (
                                              [
                                              EnumEnquiryType.business,
                                              EnumEnquiryType.helico
                                              ].includes($safeNavigationMigration(enquiry?.type))
                                              ) {
                                              <li class="list-group-item">
                                                <label>PIC :</label>
                                                @if (!enquiryFlight.captainId) {
                                                  <span
                                                    class="text-muted"
                                                    >
                                                    {{ "GENERAL.TO_BE_DEFINED" | translate }}
                                                  </span>
                                                }
                                                @if (enquiryFlight.captainId) {
                                                  <div>
                                                    @if (!crewsObj[enquiryFlight.captainId]) {
                                                      <div
                                                        class="placeholder w-100"
                                                      ></div>
                                                    }
                                                    @if (crewsObj[enquiryFlight.captainId]) {
                                                      <a
                                                        [routerLink]="
                                                            '/admin/crews/' +
                                                            enquiryFlight.captainId
                                                        "
                                                        target="_blank"
                                                        [innerText]="
                                                            crewsObj[enquiryFlight.captainId]
                                                                .lastname +
                                                            ' ' +
                                                            crewsObj[enquiryFlight.captainId]
                                                                .firstname
                                                        "
                                                        >
                                                      </a>
                                                    }
                                                    @if (
                                                      crewsObj[enquiryFlight.captainId]
                                                      ?.phoneNumber
                                                      ) {
                                                      <div
                                                        >
                                                        {{ "GENERAL.PHONE" | translate }} :
                                                        <a
                                                            [href]="
                                                                'tel:' +
                                                                crewsObj[enquiryFlight.captainId]
                                                                    .phoneNumber
                                                            "
                                                            [innerText]="
                                                                crewsObj[enquiryFlight.captainId]
                                                                    .phoneNumber
                                                            "
                                                        ></a>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </li>
                                              <li class="list-group-item">
                                                <label>SIC :</label>
                                                @if (!enquiryFlight.coPilotId) {
                                                  <span
                                                    class="text-muted"
                                                    >
                                                    {{ "GENERAL.TO_BE_DEFINED" | translate }}
                                                  </span>
                                                }
                                                @if (enquiryFlight.coPilotId) {
                                                  <div>
                                                    @if (!crewsObj[enquiryFlight.coPilotId]) {
                                                      <div
                                                        class="placeholder w-100"
                                                      ></div>
                                                    }
                                                    @if (crewsObj[enquiryFlight.coPilotId]) {
                                                      <a
                                                        [routerLink]="
                                                            '/admin/crews/' +
                                                            enquiryFlight.coPilotId
                                                        "
                                                        target="_blank"
                                                        class="me-2"
                                                        [innerText]="
                                                            crewsObj[enquiryFlight.coPilotId]
                                                                .lastname +
                                                            ' ' +
                                                            crewsObj[enquiryFlight.coPilotId]
                                                                .firstname
                                                        "
                                                        >
                                                      </a>
                                                    }
                                                    @if (
                                                      crewsObj[enquiryFlight.coPilotId]
                                                      ?.phoneNumber
                                                      ) {
                                                      <div
                                                        >
                                                        {{ "GENERAL.PHONE" | translate }} :
                                                        <a
                                                            [href]="
                                                                'tel:' +
                                                                crewsObj[enquiryFlight.coPilotId]
                                                                    .phoneNumber
                                                            "
                                                            [innerText]="
                                                                crewsObj[enquiryFlight.coPilotId]
                                                                    .phoneNumber
                                                            "
                                                        ></a>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </li>
                                              <li class="list-group-item">
                                                <label>CC :</label>
                                                @if (!enquiryFlight.stewardessIds?.length) {
                                                  <span
                                                    class="text-muted"
                                                    >
                                                    {{ "GENERAL.TO_BE_DEFINED" | translate }}
                                                  </span>
                                                }
                                                @if (enquiryFlight.stewardessIds?.length) {
                                                  <div>
                                                    @for (
                                                      stewardessId of enquiryFlight.stewardessIds
                                                      ; track
                                                      stewardessId) {
                                                      @if (!crewsObj[stewardessId]) {
                                                        <span
                                                          class="placeholder w-100"
                                                        ></span>
                                                      }
                                                      @if (crewsObj[stewardessId]) {
                                                        <a
                                                            [routerLink]="
                                                                '/admin/crews/' + stewardessId
                                                            "
                                                          target="_blank"
                                                          class="me-2"
                                                            [innerText]="
                                                                crewsObj[stewardessId].lastname +
                                                                ' ' +
                                                                crewsObj[stewardessId].firstname
                                                            "
                                                          >
                                                        </a>
                                                      }
                                                      @if (
                                                        crewsObj[stewardessId]?.phoneNumber
                                                        ) {
                                                        <div
                                                          >
                                                          {{ "GENERAL.PHONE" | translate }} :
                                                          <a
                                                                [href]="
                                                                    'tel:' +
                                                                    crewsObj[stewardessId]
                                                                        .phoneNumber
                                                                "
                                                                [innerText]="
                                                                    crewsObj[stewardessId]
                                                                        .phoneNumber
                                                                "
                                                          ></a>
                                                        </div>
                                                      }
                                                    }
                                                  </div>
                                                }
                                              </li>
                                            }
                                            <li class="list-group-item">
                                              <label>SUP</label>
                                              <div class="d-flex flex-column gap-1">
                                                <div>
                                                  <span class="fw-semibold">
                                                    {{ 'FLIGHT_BRIEF.DEPARTURE' | translate }}
                                                  </span>
                                                  @if (
                                                    !enquiryFlight
                                                    .departSupervisorIds?.length
                                                    ) {
                                                    <span
                                                      class="text-muted"
                                                      >
                                                      {{ 'GENERAL.TO_BE_DEFINED' | translate }}
                                                    </span>
                                                  }
                                                  @for (
                                                    supervisorId of
                                                    enquiryFlight.departSupervisorIds
                                                    ; track supervisorId
                                                    ) {
                                                    @if (!supervisorsObj[supervisorId]) {
                                                      <span
                                                        class="placeholder w-100"
                                                      ></span>
                                                    }
                                                    @if (supervisorsObj[supervisorId]) {
                                                      <a
                                                                [routerLink]="
                                                                    getSupervisorUrl(supervisorId)
                                                                "
                                                        target="_blank"
                                                        class="me-2"
                                                                [innerText]="
                                                                    supervisorsObj[supervisorId]
                                                                        .lastname +
                                                                    ' ' +
                                                                    supervisorsObj[supervisorId]
                                                                        .firstname
                                                                "
                                                        >
                                                      </a>
                                                      @if (
                                                        supervisorsObj[supervisorId]
                                                        ?.phoneNumber
                                                        ) {
                                                        <div
                                                          >
                                                          {{
                                                          ("GENERAL.PHONE" | translate) +
                                                          ' :'
                                                          }}
                                                          <a
                                                                    [href]="
                                                                        'tel:' +
                                                                        supervisorsObj[supervisorId]
                                                                            .phoneNumber
                                                                    "
                                                                    [innerText]="
                                                                        supervisorsObj[supervisorId]
                                                                            .phoneNumber
                                                                    "
                                                          ></a>
                                                        </div>
                                                      }
                                                    }
                                                  }
                                                </div>
                                                <div>
                                                  <span class="fw-semibold">
                                                    {{ 'FLIGHT_BRIEF.ARRIVAL' | translate }}
                                                  </span>
                                                  @if (
                                                    !enquiryFlight
                                                    .arrivalSupervisorIds?.length
                                                    ) {
                                                    <span
                                                      class="text-muted"
                                                      >
                                                      {{ 'GENERAL.TO_BE_DEFINED' | translate }}
                                                    </span>
                                                  }
                                                  @for (
                                                    supervisorId of
                                                    enquiryFlight.arrivalSupervisorIds
                                                    ; track supervisorId
                                                    ) {
                                                    @if (!supervisorsObj[supervisorId]) {
                                                      <span
                                                        class="placeholder w-100"
                                                      ></span>
                                                    }
                                                    @if (supervisorsObj[supervisorId]) {
                                                      <a
                                                                [routerLink]="
                                                                    getSupervisorUrl(supervisorId)
                                                                "
                                                        target="_blank"
                                                        class="me-2"
                                                                [innerText]="
                                                                    supervisorsObj[supervisorId]
                                                                        .lastname +
                                                                    ' ' +
                                                                    supervisorsObj[supervisorId]
                                                                        .firstname
                                                                "
                                                        >
                                                      </a>
                                                      @if (
                                                        supervisorsObj[supervisorId]
                                                        ?.phoneNumber
                                                        ) {
                                                        <div
                                                          >
                                                          {{
                                                          ("GENERAL.PHONE" | translate) +
                                                          ' :'
                                                          }}
                                                          <a
                                                                    [href]="
                                                                        'tel:' +
                                                                        supervisorsObj[supervisorId]
                                                                            .phoneNumber
                                                                    "
                                                                    [innerText]="
                                                                        supervisorsObj[supervisorId]
                                                                            .phoneNumber
                                                                    "
                                                          ></a>
                                                        </div>
                                                      }
                                                    }
                                                  }
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="card card-child mb-4">
                                          <div class="card-header">{{ "CALENDAR.LOAD_DETAILS" | translate }}</div>
                                          @if (enquiryFlight.isFerryFlight) {
                                            <div
                                              class="card-body text-center"
                                              >
                                              {{ "ENQUIRY_FLIGHTS.FERRY_FLIGHT" | translate }}
                                            </div>
                                          }
                                          @if (!enquiryFlight.isFerryFlight) {
                                            @if (
                                              enquiryFlight.enquiryType !== EnumEnquiryType.cargo
                                              ) {
                                              <div
                                                class="card-body"
                                                >
                                                PAX : {{ enquiryFlight.pax }}
                                              </div>
                                            }
                                            @if (
                                              enquiryFlight.enquiryType === EnumEnquiryType.cargo
                                              ) {
                                              <div
                                                class="card-body"
                                                >
                                                CARGO : {{ enquiryFlight.weight }}kg /
                                                {{ enquiryFlight.volume }}m³
                                              </div>
                                            }
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    @if (enquiryFlight.comment) {
                                      <div class="card card-child">
                                        <div class="card-header">{{ "CALENDAR.REMARK" | translate }}</div>
                                        <div class="card-body" [innerText]="enquiryFlight.comment"></div>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }

                      <div
                        class="modal fade"
                        id="checklist-modal"
                        tabindex="-1"
                        aria-labelledby="checklist-modal-label"
                        aria-hidden="true"
                        #modalChecklist
                        >
                        <div class="modal-dialog modal-lg">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1 class="modal-title fs-5" id="checklist-modal-label">
                                Checklist
                                @if (flightChecklistTemplate && flightChecklist) {
                                  <span
                                    class="ms-1"
                        [innerText]="
                            getFinishedCheckOnTotalForFlight(
                                flightChecklistTemplate,
                                flightChecklist
                            )
                        "
                                  ></span>
                                }
                              </h1>
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                [attr.aria-label]="'GENERAL.CLOSE' | translate"
                              ></button>
                            </div>
                            <div class="modal-body">
                              <app-enquiry-flight-checklist
                                [enquiryFlight]="selectedFlight"
                              ></app-enquiry-flight-checklist>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="modal fade"
                        id="enquiry-flight-edit-modal"
                        tabindex="-1"
                        aria-labelledby="enquiry-flight-edit-modalLabel"
                        aria-hidden="true"
                        #modalEnquiryFlightEdit
                        >
                        <div class="modal-dialog modal-xxl">
                          <div class="modal-content">
                            <app-enquiry-flight-edit
                              [enquiry]="enquiry"
                              [enquiryFlightId]="currentEnquiryFlight?.id || null"
                              [inModal]="true"
                              [currentStep]="currentEnquiryFlightStep"
                              (updatedSelectedEnquiryFlight)="assignSelectedEnquiryFlight($event)"
                            ></app-enquiry-flight-edit>
                          </div>
                        </div>
                      </div>

                      <div
                        class="modal fade"
                        id="enquiry-flight-add-modal"
                        tabindex="-1"
                        aria-labelledby="enquiry-flight-add-modalLabel"
                        aria-hidden="true"
                        #modalEnquiryFlightAdd
                        >
                        <div class="modal-dialog">
                          <div class="modal-content">
                            <app-enquiry-flight-add
                              [enquiry]="enquiry"
                              [enquiryFlights]="enquiryFlights"
                              [inModal]="true"
                              (editEnquiryFlight)="editLeg($event)"
                            ></app-enquiry-flight-add>
                          </div>
                        </div>
                      </div>
